<template>
  <div id="jobDetails">
    <div class="detail_container">
      <div class="detail_recruit_info">
        <div class="detail_recruit_title_info">
          已选中{{ this.nameList }}等岗位
        </div>
        <el-form ref="form" :model="form" label-width="90px" label-position="left">
          <el-form-item label="薪资范围：">
            <div class="salary_container">
              <el-input v-model="form.pay_range_min" placeholder="最低薪资"></el-input>
              <div class="separator">-</div>
              <el-input v-model="form.pay_range_max" placeholder="最高薪资"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="奖励金额：">
            <el-input v-model="form.bonus" placeholder="请输入该岗位内推奖励金额"></el-input>
          </el-form-item>
          <el-form-item label="所属部门：">
            <el-input v-model="form.bonus" placeholder="请输入招聘部门"></el-input>
          </el-form-item>
          <el-form-item label="招聘类型：">
            <el-radio v-model="form.typeRadio" label="内部招聘">内部招聘</el-radio>
            <el-radio v-model="form.typeRadio" label="外部招聘">外部招聘</el-radio>
            <el-radio v-model="form.typeRadio" label="内部招聘|外部招聘">内部招聘|外部招聘</el-radio>
          </el-form-item>
          <el-form-item label="是否急招：">
            <el-radio v-model="form.radio" label="1">是</el-radio>
            <el-radio v-model="form.radio" label="0">否</el-radio>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn_container">
        <el-button @click="getback">返回</el-button>
        <el-button type="primary" @click="confirmAndRelease">确认并发布职位</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/apis/inside'
export default {
  data() {
    return {
      idList: this.$route.query.idList.join(),
      nameList: this.$route.query.nameList.join(),
      active:this.$route.query.active,
      form: {
        bonus: '',
        pay_range_min: '',
        pay_range_max: '',
        typeRadio: '内部招聘',
        radio: '1',
        org_name:''
      },
    }
  },
  created() {
  },
  methods: {
    //返回
    getback() {
      this.$router.back()
    },
    //确认并发布职位
    confirmAndRelease() {
      const pay_range = this.form.pay_range_min + '-' + this.form.pay_range_max
      api.PostBatchRevise({
        id: this.idList,
        bonus: this.form.bonus, // 内推分红奖励,（必填，可为空）
        pay_range: pay_range, // 薪资范围：中间用“-”,（必填，可为空）隔开
        job_type: this.form.typeRadio, // 招聘类型
        urgency_state: this.form.radio, // 紧急标签是否显示，0：不显示，1：显示（必填，可为空）
        state: this.$route.query.active, //岗位状态信息：0：未发布，1：已发布，2：已下架
        org_name: this.form.org_name // 招聘部门
      }).then((res) => {
        if (res.code == 200) {
          this.getback()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #jobDetails {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #jobDetails {
    width: 276px * $zoom;
  }
}
#jobDetails {
  font-size: 16px * $zoom;
  position: relative;
  .detail_container {
    width: 100%;
    min-height: 100vh;
    padding-bottom: 136px;
    background: #F7F9FA;
    .detail_recruit_info {
      padding: 32px;
      background: #fff;
      .detail_recruit_title_info {
        margin-bottom: 20px;
        font-size: 36px;
        font-weight: bold;
        color: #282B32;
        line-height: 56px;
      }
      ::v-deep .el-form {
        .el-form-item {
          &:last-child {
            margin: 0;
          }
          .el-form-item__label {
            padding: 0;
            font-size: 30px;
            line-height: 64px;
            color: #666666;
          }
          .el-form-item__content {
            line-height: 64px;
            .recruit_type {
              font-size: 30px;
              color: #282B32;
            }
            .el-input {
              .el-input__inner {
                height: 64px;
                font-size: 30px;
                background: #FFFFFF;
                border-radius: 4px;
                border: 1rpx solid #C1C1C1;
                &::placeholder {
                  font-size: 30px;
                  color: #B5B5B5;
                }
              }
            }
            .salary_container {
              display: flex;
              .separator {
                margin: 0 20px;
              }
            }
            .el-radio {
              .el-radio__label {
                color: #969B9E;
              }
              .is-checked {
                .el-radio__inner {
                  background: #4EA27C;
                }
                .el-radio__label {
                  color: #282B32;
                }
              }
            }
          }
        }
      }
    }
    .btn_container {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 96px;
      background: #eee;
      .el-button {
        width: 35%;
        height: 100%;
        border: none;
        font-size: 30px;
        color: #282B32;
        border-radius: 0;
      }
      .el-button--primary {
        width: 65%;
        margin: 0;
        background: #4EA27C;
        color: #FFFFFF;
      }
    }
  }
}

</style>